// extracted by mini-css-extract-plugin
module.exports = {"v1rs1hat":"v1rs1hat","c1v9l41m":"c1v9l41m","p124121w":"p124121w"};